import { render, staticRenderFns } from "./VisitationPurposes.vue?vue&type=template&id=4f61d880&"
import script from "./VisitationPurposes.vue?vue&type=script&lang=js&"
export * from "./VisitationPurposes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports